@if (orders$ | async; as orderHistory) {
    @if (breadcrumbs$ | async; as breadcrumbs) {
        <aimo-breadcrumb
            [hideTitle]="true"
            [showBackLink]="false"
            [addFrontPageLink]="false"
            [normalBreadCrumbs]="breadcrumbs">
        </aimo-breadcrumb>
    }

    <cx-page-slot position="TopContent"></cx-page-slot>
    <cx-page-slot position="PageDescription"></cx-page-slot>

    <div class="noPrint">
        @for (order of getUnPaidOrders(orderHistory); track order) {
            <ng-container
                *ngTemplateOutlet="
                    notification;
                    context: {
                        level: 'ERROR',
                        order: order,
                        textKey: 'aimo.orderhistory.unPaidOrder',
                        textKeyLink: 'aimo.orderhistory.unPaidOrderLink',
                    }
                "></ng-container>
        }
    </div>
    <div [formGroup]="searchForm">
        <div class="row cx-search-criteria noPrint">
            <div class="col-md-8 col-12 cx-search-criteria-find">
                <aimo-cx-input
                    (afterChange)="doUrlSearch(true)"
                    [placeholder]="'aimo.orderhistory.search'"
                    [parentForm]="searchForm"
                    [nameForm]="'search'"
                    [inputIcon]="'icon-magnifying-glass icon-petrol-blue'"></aimo-cx-input>
            </div>
            <div class="col-md-4 col-12 range-dates pt-2 pt-md-0">
                <aimo-datepicker-input
                    class="date-from"
                    [idName]="'delivery_date_from'"
                    [selectedDate]="convertDate(orderHistory.searchFrom)"
                    (afterChange)="doUrlSearch(true)"
                    [placeholder]="'aimo.orderhistory.dateFrom' | cxTranslate"
                    [parentForm]="searchForm"
                    [customDayTemplate]="customDay"
                    [nameForm]="'from'"></aimo-datepicker-input>
                <span class="date-divider"> - </span>
                <aimo-datepicker-input
                    class="date-to"
                    [idName]="'delivery_date_to'"
                    (afterChange)="doUrlSearch(true)"
                    [placeholder]="'aimo.orderhistory.dateTo' | cxTranslate"
                    [parentForm]="searchForm"
                    [customDayTemplate]="customDay"
                    [selectedDate]="convertDate(orderHistory.searchTo)"
                    [nameForm]="'to'"></aimo-datepicker-input>
            </div>
        </div>
        <ng-template
            #customDay
            let-date
            let-currentMonth="currentMonth"
            let-today="today"
            let-selected="selected"
            let-disabled="disabled"
            let-focused="focused">
            <button
                class="calendar-cell calendar-day link"
                [ngClass]="{ focused: focused, selected: selected, disabled: disabled }">
                {{ date.day }}
            </button>
        </ng-template>
        <div class="row cx-facets noPrint">
            <div class="col-12">
                @for (facet of orderHistory.facets; track facet.code) {
                    @if (facet.values.length > 1) {
                        <div class="aimo-facet">
                            <button
                                class="heading btn-facet"
                                [ngClass]="{ selected: facets.length === 0 }"
                                (click)="toggleFacet(null, null); pushGtmEvent('orderhistory-facets')">
                                {{ 'aimo.orderhistory.allStatuses' | cxTranslate }}
                                <span class="amount">{{ getTotalOrders(orderHistory.facets) }}</span>
                            </button>
                        </div>
                    }
                    @for (facetValue of facet.values; track facetValue.code) {
                        @if (facetValue.count > 0) {
                            <div class="aimo-facet">
                                <button
                                    class="heading btn-facet"
                                    [ngClass]="{ selected: facetValue.selected }"
                                    (click)="toggleFacet(facet, facetValue); pushGtmEvent('orderhistory-facets')">
                                    {{ 'aimo.orderhistory.' + facet.code + '.' + facetValue.name | cxTranslate }}
                                    <span class="amount">{{ facetValue.count }}</span>
                                </button>
                            </div>
                        }
                    }
                }
            </div>
        </div>
        <div class="bg-petrol-light cx-pagination-wrapper noPrint">
            <div class="total-results-wrapper">
                <div class="total-results">
                    {{ 'aimo.orderhistory.title' | cxTranslate }} {{ resultSpan }} /
                    {{ orderHistory.pagination.totalResults }}
                </div>
                <div class="page-size">
                    <span class="mr-2">{{ 'aimo.orderhistory.showAmount' | cxTranslate }}</span>
                    <ng-select
                        class="aimo-select"
                        [id]="'pageSizePicker'"
                        [bindLabel]="'code'"
                        [bindValue]="'code'"
                        [clearable]="false"
                        [closeOnSelect]="true"
                        [formControlName]="'pageSize'"
                        [items]="pageSizes"
                        [multiple]="false"
                        [placeholder]="'aimo.orderhistory.pageSize.placeholder' | cxTranslate"
                        [searchable]="false"
                        (change)="switchPage(0)">
                    </ng-select>
                </div>
            </div>
            <cx-pagination [pagination]="orderHistory.pagination" (viewPageEvent)="switchPage($event)"></cx-pagination>
        </div>
    </div>
    <div class="aimo-order-history-days">
        @for (day of orderHistory.dayGroupedOrders; track day.date) {
            <aimo-order-history-day
                [dayInitialized]="orderHistory.dayGroupedOrders.length === 1"
                [selectedSearchFacets]="facets"
                [searchTerm]="searchForm.controls['search'].value"
                [day]="day"
                [open]="orderHistory.dayGroupedOrders.length === 1"></aimo-order-history-day>
        }
    </div>

    <cx-page-slot position="BottomContent"></cx-page-slot>
}

<ng-template #notification let-level="level" let-order="order" let-textKey="textKey" let-textKeyLink="textKeyLink">
    <div class="notification" [ngClass]="level === 'INFO' ? 'notification-MESSAGE' : 'notification-' + level">
        <div class="left-side">
            <i class="aimo-icon icon-inline icon-{{ level }} mr-2"></i>
        </div>
        <div class="d-inline text-sm middle">
            <span
                [innerHTML]="textKey | cxTranslate: { order: order?.code }"
                [ngClass]="{ 'mr-1': order?.code }"></span>
            @if (order?.code) {
                <span
                    class="cursor-pointer text-underline link"
                    [innerHTML]="textKeyLink | cxTranslate: { order: order?.code }"
                    (click)="payNow(order?.code)"></span>
            }
        </div>
        <div class="right-side"></div>
    </div>
</ng-template>
